/**
 * In-memory session for usage API calls (set from AppProvider on auth change).
 */

export type UsageSession = {
  userId: string;
  email: string;
  planHint: string;
  isAdmin: boolean;
  lang: "DA" | "EN";
};

let session: UsageSession | null = null;

export function setUsageSession(next: UsageSession | null) {
  session = next;
}

export function getUsageSession(): UsageSession | null {
  return session;
}

export function planHintFromSubscription(sub: { plan?: string; status?: string } | null): string {
  if (!sub) return "free";
  return String(sub.plan || sub.status || "free");
}
